// import React from "react";
// import { Users, ShoppingBag, MessageSquare, Settings } from 'lucide-react';
// import { Link } from "react-router-dom";

// const AdminDashboard = ({ totalOrders, totalUsers }) => {
//   const adminCards = [
//     {
//       title: "Total Orders",
//       link: "/admin/orders",
//       linkText: "Manage all your orders",
//       icon: <ShoppingBag size={32} />,
//       value: totalOrders.toLocaleString(), // Use dynamic data here
//       growth: "",
//       bgColor: "bg-blue-100",
//       iconColor: "text-blue-500",
//       borderColor: "border-blue-200"
//     },
//     {
//       title: "Total Users",
//       link: "/admin/users",
//       linkText: "View and manage users",
//       icon: <Users size={32} />,
//       value: totalUsers.toLocaleString(), // Use dynamic data here
//       growth: "",
//       bgColor: "bg-green-100",
//       iconColor: "text-green-500",
//       borderColor: "border-green-200"
//     },
//     {
//       title: "Support Messages",
//       link: "/admin/support-messages",
//       linkText: "Customer support tickets",
//       icon: <MessageSquare size={32} />,
//       value: "",
//       growth: "",
//       bgColor: "bg-purple-100",
//       iconColor: "text-purple-500",
//       borderColor: "border-purple-200"
//     },
//     {
//       title: "Settings",
//       link: "/admin/settings",
//       linkText: "Configure system settings",
//       icon: <Settings size={32} />,
//       value: "",
//       growth: "",
//       bgColor: "bg-gray-100",
//       iconColor: "text-gray-500",
//       borderColor: "border-gray-200"
//     }
//   ];

//   return (
//     <div className="container py-6">
//       <div className="row mb-4">
//         <div className="col-12">
//           <p className="text-gray-500">Welcome back! Here's your dashboard overview</p>
//         </div>
//       </div>

//       <div className="row g-4">
//         {adminCards.map((card, index) => (
//           <div key={index} className="col-xl-3 col-lg-6 col-md-6">
//             <Link 
//               to={card.link} 
//               className="text-decoration-none"
//               style={{ display: 'block' }}
//             >
//               <div className={`card shadow-sm h-100 border ${card.borderColor} hover:shadow-lg transition-all duration-200`}>
//                 <div className={`card-body p-4 ${card.bgColor}`}>
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <div className={`p-2 rounded-circle ${card.bgColor} ${card.iconColor}`}>
//                       {card.icon}
//                     </div>
//                     {card.growth && (
//                       <span className="badge bg-success text-white p-2">
//                         {card.growth}
//                       </span>
//                     )}
//                   </div>

//                   <h5 className="card-title mb-1 text-lg font-semibold">{card.title}</h5>

//                   {card.value && (
//                     <h3 className="display-6 fw-bold mb-0">{card.value}</h3>
//                   )}

//                   <span className="btn card-text mt-2 mb-0 text-gray-600 text-sm">
//                     {card.linkText}
//                   </span>
//                 </div>
//               </div>
//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

import React, { useState } from "react";
import { Users, ShoppingBag, MessageSquare, Settings } from 'lucide-react';
import { Link } from "react-router-dom";

const AdminDashboard = ({ totalOrders, totalUsers }) => {
  const [hoveredCard, setHoveredCard] = useState(null);
  
  const adminCards = [
    {
      title: "Total Orders",
      link: "/admin/orders",
      linkText: "Manage all your orders",
      icon: <ShoppingBag size={32} />,
      value: totalOrders.toLocaleString(),
      growth: "",
      bgColor: "bg-primary bg-opacity-10",
      iconColor: "text-primary",
      borderColor: "border-primary",
      hoverBgColor: "bg-primary bg-opacity-20"
    },
    // {
    //   title: "Total Users",
    //   link: "/admin/users",
    //   linkText: "View and manage users",
    //   icon: <Users size={32} />,
    //   value: totalUsers.toLocaleString(),
    //   growth: "",
    //   bgColor: "bg-success bg-opacity-10",
    //   iconColor: "text-success",
    //   borderColor: "border-success",
    //   hoverBgColor: "bg-success bg-opacity-20"
    // },
    {
      title: "Support Messages",
      link: "/admin/support-messages",
      linkText: "Customer support tickets",
      icon: <MessageSquare size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-info bg-opacity-10",
      iconColor: "text-info",
      borderColor: "border-info",
      hoverBgColor: "bg-info bg-opacity-20"
    },
    {
      title: "Settings",
      link: "/admin/settings",
      linkText: "Configure system settings",
      icon: <Settings size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-secondary bg-opacity-10",
      iconColor: "text-secondary",
      borderColor: "border-secondary",
      hoverBgColor: "bg-secondary bg-opacity-20"
    }
  ];

  return (
    <div className="container-fluid py-4 px-md-5">
      <style>
        {`
          .dashboard-card {
            transition: all 0.3s ease;
            transform: translateY(0);
            border-radius: 1rem;
            overflow: hidden;
            position: relative;
          }
          .dashboard-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          }
          .dashboard-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 5px;
            background: linear-gradient(90deg, var(--bs-primary), var(--bs-info));
            transform: scaleX(0);
            transform-origin: left;
            transition: transform 0.3s ease;
          }
          .dashboard-card:hover::before {
            transform: scaleX(1);
          }
          .icon-container {
            transition: all 0.3s ease;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          }
          .dashboard-card:hover .icon-container {
            transform: scale(1.1) rotate(5deg);
            box-shadow: 0 8px 15px rgba(0,0,0,0.1);
          }
          .dashboard-header {
            background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
            border-radius: 1rem;
            padding: 2rem;
            margin-bottom: 2rem;
            position: relative;
            overflow: hidden;
          }
          .dashboard-header::after {
            content: '';
            position: absolute;
            top: -50px;
            right: -50px;
            width: 200px;
            height: 200px;
            border-radius: 50%;
            background: rgba(255,255,255,0.2);
          }
          .stat-value {
            background: linear-gradient(90deg, var(--bs-primary), var(--bs-info));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 700;
          }
          @media (max-width: 768px) {
            .dashboard-card {
              margin-bottom: 1rem;
            }
          }
          /* Typography improvements */
          .dashboard-title {
            font-size: 2.5rem;
            font-weight: 700;
            line-height: 1.2;
            margin-bottom: 0.5rem;
            color: #2c3e50;
          }
          .dashboard-subtitle {
            font-size: 1.1rem;
            font-weight: 400;
            color: #6c757d;
            margin-bottom: 0;
          }
          .card-title-text {
            font-size: 1.25rem;
            font-weight: 600;
            line-height: 1.4;
            color: #2c3e50;
            margin-bottom: 0.5rem;
          }
          .card-value {
            font-size: 2rem;
            font-weight: 700;
            line-height: 1.2;
            margin-bottom: 0.5rem;
          }
          .card-link-text {
            font-size: 0.95rem;
            font-weight: 500;
            line-height: 1.4;
          }
          .section-title {
            font-size: 1.5rem;
            font-weight: 600;
            line-height: 1.3;
            color: #2c3e50;
            margin-bottom: 1rem;
          }
          .activity-title {
            font-size: 1.1rem;
            font-weight: 600;
            line-height: 1.4;
            color: #2c3e50;
            margin-bottom: 0.25rem;
          }
          .activity-time {
            font-size: 0.875rem;
            font-weight: 400;
            color: #6c757d;
          }
          .btn-text {
            font-size: 1rem;
            font-weight: 500;
          }
        `}
      </style>
      
      <div className="dashboard-header text-center mb-5">
        <h1 className="dashboard-title">Admin Dashboard</h1>
        <p className="dashboard-subtitle">Welcome back! Here's your dashboard overview</p>
      </div>
      
      <div className="row g-4">
        {adminCards.map((card, index) => (
          <div key={index} className="col-xl-3 col-lg-6 col-md-6">
            <Link 
              to={card.link} 
              className="text-decoration-none"
              style={{ display: 'block' }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div 
                className={`card shadow-sm h-100 border ${card.borderColor} dashboard-card ${hoveredCard === index ? card.hoverBgColor : card.bgColor}`}
              >
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div 
                      className={`icon-container p-3 rounded-circle ${card.bgColor} ${card.iconColor} d-flex align-items-center justify-content-center`}
                      style={{ 
                        width: '64px', 
                        height: '64px',
                        background: 'white'
                      }}
                    >
                      {card.icon}
                    </div>
                    {card.growth && (
                      <span className="badge bg-success text-white p-2">
                        {card.growth}
                      </span>
                    )}
                  </div>
                  
                  <h5 className="card-title-text">{card.title}</h5>
                  {card.value && (
                    <h3 className="card-value stat-value">{card.value}</h3>
                  )}
                  <div className="d-flex align-items-center mt-3">
                    <span className={`text-decoration-none ${card.iconColor} card-link-text`}>
                      {card.linkText}
                    </span>
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="16" 
                      height="16" 
                      fill="currentColor" 
                      className={`bi bi-arrow-right-short ms-1 ${card.iconColor}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                    </svg>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;